import type { ReactNode } from 'react';
import type { OutreachCounts } from '@discovr/types';
import { inboxSubline } from './inboxTabs';

export function InboxHeader({
  counts,
  controls,
}: {
  counts?: OutreachCounts;
  /** Search / Sort by / Filters, on the title row (Figma). */
  controls?: ReactNode;
}) {
  return (
    // Figma 505:49936: SPACE_BETWEEN with a 12px gap; ml-auto keeps the controls right even when the row wraps.
    <header className="flex flex-wrap items-center justify-between gap-3">
      <div>
        <h1 className="text-xl font-medium text-foreground">Outreach</h1>
        {counts ? <p className="mt-1 text-sm text-muted-foreground">{inboxSubline(counts)}</p> : null}
      </div>
      <div data-testid="inbox-controls" className="ml-auto flex flex-wrap items-center justify-end gap-3">
        {controls}
      </div>
    </header>
  );
}
